import angular from 'angular';
import focusWhenDirective from './focusWhenDirective';
import autofocusDirective from './autofocusDirective';

angular
	.module('sh.focusWhen', [])
	.directive('shFocusWhen', focusWhenDirective)
	.directive('shAutofocus', autofocusDirective);
